import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';
import {getElevatorConfigurations} from '../../actions/elevatorsActions';
import {Layout, PageHeader} from '../../components';
import ConfigurationsForm from './ConfigurationsForm';

const ElevatorConfigurations = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {id} = useParams();
  const {elevatorConfigurations} = useSelector(s => s.elevators);

  const onBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    dispatch(getElevatorConfigurations(id));
  }, []);

  return (
    <Layout>
      <PageHeader onBack={onBack} />
      {elevatorConfigurations && (
        <ConfigurationsForm id={id} configurations={elevatorConfigurations} />
      )}
    </Layout>
  );
};

export default ElevatorConfigurations;
